<template>
  <div class="col-md-s">
       <div id="data-list-thumb-view" class="data-list-container" >
    
    <vs-table
      ref="table"
      noDataText="Tabloda Veri Yok"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="products"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">İşlemler</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>PDF</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Excel</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Yeni Ürün</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Ürün Resmİ</vs-th>
        <vs-th sort-key="productName">Ürün Adi</vs-th>
        <vs-th sort-key="productCategory">Kategori</vs-th>
        <vs-th sort-key="stock">Stok</vs-th>
        <vs-th sort-key="price">Fiyat</vs-th>
        <vs-th>İşlem</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody ref="tbody">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container">
              <img :src="tr.img" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ tr.productName }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category putTextCenter">{{ tr.productCategory }}</p>
            </vs-td>

            <vs-td v-bind:title="tr.beautifyStockLabel">
              <p class="product-price" style="text-align: center;">{{tr.totalStock}}</p>
            </vs-td>
            <vs-td>
              <p class="product-price" style="text-align: center;">{{ tr.price }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="TruckIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="transferItem(tr)"
              />
              <feather-icon
                icon="EditIcon"
                class="ml-2"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData()"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";

export default {
  components: {
  },
  data() {
    return {
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      transferProduct: false,
      sidebarData: {},
      products: [],
      productToSent: [],
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.products.length;
    },
  },
  methods: {
    getProducts: async function () {
      this.products = await repository
        .getAll("Product/getProductsV2")
        .then((r) => {
          if (!r.isSuccessful) {
            this.$vs.notify({
              title: "Hata Ürünler Listesi",
              text: `${this.products.exceptionMessage}`,
              color: "danger",
              icon: "warning",
            });
          } else return r.list;
        });
      this.products = repository.convertToJSON(this.products, "stock");
      try {
        for (let i = 0; i < this.products.length; i++) {
          let x = this.products[i];
          if (x.stock && x.stock.length > 0) {
            let sum = 0;
            let text = "";
            for (let j = 0; j < x.stock.length; j++) {
              sum += x.stock[j].stock;
              text += x.stock[j].stock + " Adet " + x.stock[j].wareHouse + "\n";
            }
            x.totalStock = sum;

            x.beautifyStockLabel = text;
          } else x.totalStock = "Yok";
        }
      } catch (e) {
        console.error(e);
      }
      return this.products;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      console.warn(id);
    },
    editData() {
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    transferItem(data) {
      this.productToSent = data;
      this.transferProduct = true;
    },
  },
  created() {
    this.getProducts();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss" scoped>
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--tbody {
      max-height: 65vh;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          &:first-child {
            border-top-left-radius: 0.2rem;
            border-bottom-left-radius: 0.2rem;
          }
          &:last-child {
            border-top-right-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;
          }
          &.img-container {
            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 10px;
            }
          }
        }
        td.td-check {
          padding: 1px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 400;
        }
      }
      th.td-check {
        padding: 0 5px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
@media only screen and (max-width: 300px) {
  body {
    overflow: scroll !important;
  }
}
</style>
